import { render, staticRenderFns } from "./gateIdentify.vue?vue&type=template&id=3b1a7daa&scoped=true&"
import script from "./gateIdentify.vue?vue&type=script&lang=js&"
export * from "./gateIdentify.vue?vue&type=script&lang=js&"
import style0 from "./gateIdentify.vue?vue&type=style&index=0&id=3b1a7daa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1a7daa",
  null
  
)

export default component.exports